"use strict";

exports.__esModule = true;
exports.DsToastContextual = void 0;

var _reactstrap = require("reactstrap");

var _jsxRuntime = require("react/jsx-runtime");

var DsToastContextual = function DsToastContextual(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'discreet-info' : _ref$color,
      _ref$additionalClassN = _ref.additionalClassNames,
      additionalClassNames = _ref$additionalClassN === void 0 ? '' : _ref$additionalClassN,
      children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactstrap.UncontrolledAlert, {
    className: additionalClassNames,
    color: color,
    closeClassName: 'py-4',
    children: children
  });
};

exports.DsToastContextual = DsToastContextual;